/**
 * @file useDebounced.ts
 * @description Значение с задержкой (phase19.28 этап А): поиск магазинов,
 * проверка slug и поиск владельца не дёргают сервер на каждую букву.
 */

import { useEffect, useState } from "react";

export function useDebounced<T>(value: T, delay: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = window.setTimeout(() => setDebounced(value), delay);
    return () => window.clearTimeout(timer);
  }, [value, delay]);
  return debounced;
}
